import { Component, input } from '@angular/core';
import { IonButton, IonSpinner } from '@ionic/angular/standalone';

@Component({
  selector: 'x-button',
  standalone: true,
  imports: [IonButton, IonSpinner],
  templateUrl: './x-button.component.html',
  styleUrl: './x-button.component.scss'
})
export class XButtonComponent {
  label = input.required<string>();
  type = input<'button' | 'submit' | 'reset'>('button');
  disabled = input<boolean>(false);
  loading = input<boolean>(false);
  expand = input<'block' | 'full' | undefined>('block');
  variant = input<'primary' | 'secondary'>('primary');
  fill = input<'clear' | 'outline' | 'solid' | undefined>('solid');
  color = input<string | undefined>(undefined);
  size = input<'small' | 'default' | 'large' | undefined>('default');
  cssClass = input<string>('');
  loadingText = input<string>('');
}
